// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailsVitals_block__pBbFz","height":"DetailsVitals_height__7BgPl","fields":"DetailsVitals_fields__9WXFJ"};